<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="9" offset-md="1" offset-lg="2" lg="8">
        <FormWrapper
          @back="handleFormBack()"
          @next="handleFormNext()"
          @finish="handleFormFinish()"
          :showBackButton="showBackButton"
          :showFinishButton="showFinishButton"
          :showNextButton="showNextButton"
          :currentStep="currentFormStep"
          :totalSteps="totalSteps"
        >
          <TheUserForm v-if="currentFormStep === 1" @input-change="handleFormsInputChange" />
          <TheFunnelForm v-if="currentFormStep === 2" @input-change="handleFormsInputChange" />
          <TheMetricsForm v-if="currentFormStep === 3" @input-change="handleFormsInputChange" />
        </FormWrapper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormWrapper from '../components/FormWrapper';
import TheUserForm from '../components/TheUserForm';
import TheFunnelForm from '../components/TheFunnelForm';
import TheMetricsForm from '../components/TheMetricsForm';

export default {
  name: 'Home',
  data: function() {
    return {
      currentFormStep: 1,
      formSteps: ['TheUserForm', 'TheFunnelForm', 'TheMetricsForm'],

      //dados step 1:
      name: '',
      email: '',
      telephone: '',
      companyName: '',
      cargo: '',
      qtdFunc: null,
      qtdVend: null,

      //dados step 2:
      valorMeta: null,
      prazoMeta: null,
      ticketMedio: null,
      etapasFunil: null

      //dados step 3:
    };
  },

  components: {
    FormWrapper,
    TheUserForm,
    TheFunnelForm,
    TheMetricsForm
  },
  methods: {
    handleFormBack() {
      if (this.currentFormStep > 0) {
        this.currentFormStep -= 1;
      }
    },
    handleFormNext() {
      this.currentFormStep += 1;
    },
    handleFormsInputChange(field, value) {
      this[field] = value;
    },
    handleFormFinish() {
      this.$router.push('/simulador');
    }
  },
  computed: {
    showBackButton() {
      return this.currentFormStep !== 1;
    },
    showFinishButton() {
      if (this.isLastStep) {
        return true;
      } else {
        return false;
      }
    },
    showNextButton() {
      return !this.isLastStep;
    },
    totalSteps() {
      return this.formSteps.length;
    },
    isLastStep() {
      return this.totalSteps === this.currentFormStep;
    }
  }
};
</script>
